import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);



var url = EaBIM.backurl;
if (window.location.hostname.toLocaleLowerCase().includes("bimseek")) {
    url = EaBIM.backurls;
}
if (window.location.hostname.toLocaleLowerCase().includes("deepdecor")) {
    url = EaBIM.backurls2;
}


export default new Vuex.Store({
    // modules: { adminSetting },
    // 这是权限
    state: {
        firstlogin: false,
        shortName: "",
        companyLogo: "",
        permissions: [],
        pid: "",
        Company: "",
        bid: "",
        xid: "",
        isClickProject: false,
        token: "",
        xidName: "",
        roleName: "",
        jobs: [],
        ProjectList: [],
        paths: "",
        isProject: false,
        ifEnterprise: false,
        uid: "",
        UserImgs: "",
        adminSetting: {
            //平台设置
            isHave: false,
            adst02: "",
            adst03: "",
            adst05: "",
            adst06: "",
            ptbaArr: ""
        },
        // 振南
        // baseUrl: 'http://192.168.1.232:64305',
        // 群坡
        // baseUrl: 'http://192.168.1.237:64305',
        // baseUrl: 'http://8.153.175.200:8012',
        baseUrl: url,
        // 温帅韬
        // baseUrl: 'http://192.168.1.180:64305',
        //正式环境
        // baseUrl: 'https://xtapi.eabim.cn:8020',
        userImgs: null,
        btnStyle: ["btnss", "btns", "btns", "btns"],
        nums: 3,
        RouterPath: "",
        MenuTemplateList: [],
        projectfunctiontemplates: []
    },
    mutations: {
        pidUpdate(state, gid) {
            state.pid = gid;
        },
        updateToken(state, token) {
            state.token = token;
        },
        sessionModelUrl2(state, url) {
            state.sessionModelUrl = url;
        },
        xidNameUpdata(state, xidName) {
            state.xidName = xidName;
        },
        xidUpdata(state, xid) {
            state.xid = xid;
        },
        updataisClickProject2(state) {
            state.isClickProject = false;
        },
        SetMenuTemplate(state, list) {
            state.MenuTemplateList = list;
        },
        projectfunctiontemplates(state, list) {
            state.projectfunctiontemplates = list;
        },
    },
    actions: {

    },
    getters: {
        permissions: state => state.permissions
    }
});